// PublicLayout — chrome for pages that are visible without authentication.
//
// Mirrors the landing-page header (white canvas, ember text, gold CTA) so the
// transition from /  →  /events  →  /events/:id stays visually coherent. When
// a logged-in user visits, the nav swaps the "Sign in / Get started" pair for
// a single "Open dashboard" link that drops them into their role's home.
//
// Auth-gated actions inside the wrapped pages (e.g. EventDetailPage's "Buy
// tickets" button → /events/:id/checkout) continue to flow through
// ProtectedRoute, which sends unauthenticated users to /login first.
import { Link, Outlet } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { useAuthStore } from '@/store/auth.store'
import UserMenu from './UserMenu'

export default function PublicLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  return (
    <div className="min-h-screen bg-white text-ember antialiased flex flex-col">
      <header className="px-6 lg:px-10 py-5 border-b border-[#EDE5D8]/60">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src="/logo-mark.svg"
              alt=""
              className="h-7 w-7 select-none"
              draggable={false}
            />
            <span className="font-extrabold text-base tracking-tight">Kaat</span>
          </Link>

          <nav className="flex items-center gap-2 sm:gap-6 text-sm font-medium">
            <Link
              to="/events"
              className="hidden sm:inline text-stone hover:text-ember transition-colors"
            >
              Browse events
            </Link>

            {isAuthenticated ? (
              <UserMenu variant="public" />
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-stone hover:text-ember transition-colors px-2 sm:px-0"
                >
                  Sign in
                </Link>
                <Link
                  to="/register"
                  className="inline-flex items-center gap-1.5 bg-ember text-white hover:bg-ember/90 px-4 py-2 rounded-full font-semibold transition-colors"
                >
                  Get started
                  <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
